"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnboardingListGate = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const backendImport_1 = require("@front/backendImport");
const component_1 = require("@front/layouts/default-layout/component");
//@ts-ignore                
let rwsTemplate = T.html `${(0, fast_element_1.when)(x => x.isAdmin, (0, fast_element_1.html) `<onboarding-list></onboarding-list>`, (0, fast_element_1.html) `<onboarding-user-list></onboarding-user-list>`)}`;
const styles = null;
const shadowOptions = { "mode": "open" };
let OnboardingListGate = class OnboardingListGate extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.isAdmin = false;
    }
    connectedCallback() {
        this.isAdmin = component_1.DefaultLayout.USER.role === backendImport_1.UserRoles.SUPER_ADMIN;
        super.connectedCallback();
    }
};
exports.OnboardingListGate = OnboardingListGate;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], OnboardingListGate.prototype, "isAdmin", void 0);
exports.OnboardingListGate = OnboardingListGate = __decorate([
    (0, client_1.RWSView)('onboarding-list-gate', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], OnboardingListGate);
OnboardingListGate.defineComponent();
